import {type RankedDivisionTypes, type RankedSubDivisionTypes} from './types.ts'
import {type NonFunctionProperties} from '@colonist/types'

export interface DivisionBoundary {
    division: RankedDivisionTypes
    subdivision: RankedSubDivisionTypes
    upperBound: number
}

export interface DivisionPromotionDemotionBoundary {
    division: RankedDivisionTypes
    subdivision: RankedSubDivisionTypes
    boundary: number
}

export class RankedDivisionState {
    readonly divisionType: RankedDivisionTypes
    readonly subdivisionType: RankedSubDivisionTypes
    readonly demotionDivisionBoundary: DivisionPromotionDemotionBoundary
    readonly promotionDivisionBoundary: DivisionPromotionDemotionBoundary

    constructor(divisionType: RankedDivisionTypes, subDivision: RankedSubDivisionTypes, demotionDivisionBoundary: DivisionPromotionDemotionBoundary, promotionDivisionBoundary: DivisionPromotionDemotionBoundary) {
        this.divisionType = divisionType
        this.subdivisionType = subDivision
        this.demotionDivisionBoundary = demotionDivisionBoundary
        this.promotionDivisionBoundary = promotionDivisionBoundary
    }

    static deserialize(data: NonFunctionProperties<RankedDivisionState>) {
        return new RankedDivisionState(data.divisionType, data.subdivisionType, data.demotionDivisionBoundary, data.promotionDivisionBoundary)
    }
}
